// extracted by mini-css-extract-plugin
module.exports = {"link":"Navigation_link__3cAGu","activeLink":"Navigation_activeLink__13XK9 Navigation_link__3cAGu"};